module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "confirmacaoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "confirmacaoModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content panel-danger"
  }, [_c('div', {
    staticClass: "modal-header panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "confirmacaoModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.tituloModal))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n          " + _vm._s(_vm.mensagemModal) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.deletarStatus(_vm.statusParaApagar)
      }
    }
  }, [_vm._v("Confirmar")])])])])]), _vm._v(" "), _c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirListagem),
      expression: "exibirListagem"
    }],
    staticClass: "row center-block"
  }, [_c('h2', [_vm._v("Listagem")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirNomeMaquina),
      expression: "!exibirNomeMaquina"
    }],
    staticClass: "box-title"
  }, [_vm._v("Listagem das máquinas instaladas")]), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirNomeMaquina),
      expression: "exibirNomeMaquina"
    }],
    staticClass: "box-title"
  }, [_vm._v("Alterar Nome da Máquina")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirNomeMaquina),
      expression: "!exibirNomeMaquina"
    }],
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.maquinas), function(maquina) {
    return _c('tr', {
      key: maquina.id
    }, [_c('td', [_c('a', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          _vm.alterarNomeMaquina(maquina)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v("  " + _vm._s(maquina.nomemaquina))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(maquina.mac))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(maquina.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(maquina.updated_at))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          _vm.detalharMaquina(maquina)
        }
      }
    }, [_vm._m(2, true)])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirNomeMaquina),
      expression: "exibirNomeMaquina"
    }],
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "nomeDaMaquina"
    }
  }, [_vm._v("Máquina")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nomemaquinaTemporario),
      expression: "nomemaquinaTemporario"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "id": "nomeDaMaquina"
    },
    domProps: {
      "value": (_vm.nomemaquinaTemporario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nomemaquinaTemporario = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirNomeMaquina),
      expression: "exibirNomeMaquina"
    }],
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.voltarAtualizarNomeMaquina()
      }
    }
  }, [_vm._v("Voltar")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.atualizarNomeMaquina()
      }
    }
  }, [_vm._v("Atualizar os Dados")])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirListagem),
      expression: "!exibirListagem"
    }],
    staticClass: "row center-block"
  }, [_c('h2', [_c('a', {
    on: {
      "click": function($event) {
        _vm.exibirListagem = true
      }
    }
  }, [_vm._v("Listagem ")]), _c('small', [_vm._v("Legendas")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirFuncao),
      expression: "exibirFuncao"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.maquinaDetalhe.nomemaquina) + " - Funções")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirAtualizarFuncao),
      expression: "!exibirAtualizarFuncao"
    }],
    staticClass: "box-body no-padding table-responsive  col-md-12"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_vm._m(3), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Texto")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.funcoes.f0.texto) + " "), _c('a', {
    staticClass: "btn btn-sm",
    on: {
      "click": function($event) {
        _vm.selecionarFuncao(0)
      }
    }
  }, [_vm._m(4)])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.funcoes.f1.texto) + " "), _c('a', {
    staticClass: "btn btn-sm",
    on: {
      "click": function($event) {
        _vm.selecionarFuncao(1)
      }
    }
  }, [_vm._m(5)])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.funcoes.f2.texto) + " "), _c('a', {
    staticClass: "btn btn-sm",
    on: {
      "click": function($event) {
        _vm.selecionarFuncao(2)
      }
    }
  }, [_vm._m(6)])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.funcoes.f3.texto) + " "), _c('a', {
    staticClass: "btn btn-sm",
    on: {
      "click": function($event) {
        _vm.selecionarFuncao(3)
      }
    }
  }, [_vm._m(7)])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.funcoes.f4.texto) + " "), _c('a', {
    staticClass: "btn btn-sm",
    on: {
      "click": function($event) {
        _vm.selecionarFuncao(4)
      }
    }
  }, [_vm._m(8)])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.funcoes.f5.texto) + " "), _c('a', {
    staticClass: "btn btn-sm",
    on: {
      "click": function($event) {
        _vm.selecionarFuncao(5)
      }
    }
  }, [_vm._m(9)])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.funcoes.f6.texto) + " "), _c('a', {
    staticClass: "btn btn-sm",
    on: {
      "click": function($event) {
        _vm.selecionarFuncao(6)
      }
    }
  }, [_vm._m(10)])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirAtualizarFuncao),
      expression: "exibirAtualizarFuncao"
    }],
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "textoDaFuncao"
    }
  }, [_vm._v(_vm._s(_vm.funcaoSelecionada.funcao))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcaoSelecionada.texto),
      expression: "funcaoSelecionada.texto"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "textoDaFuncao"
    },
    domProps: {
      "value": (_vm.funcaoSelecionada.texto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.funcaoSelecionada, "texto", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirAtualizarFuncao),
      expression: "exibirAtualizarFuncao"
    }],
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.voltarAtualizarFuncao()
      }
    }
  }, [_vm._v("Voltar")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.atualizarFuncao()
      }
    }
  }, [_vm._v("Atualizar Função")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirStatus),
      expression: "exibirStatus"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.maquinaDetalhe.nomemaquina) + " - Status")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirAtualizarStatus),
      expression: "!exibirAtualizarStatus"
    }],
    staticClass: "box-body no-padding table-responsive  col-md-12"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_vm._m(11), _vm._v(" "), _vm._l((_vm.legendas), function(legenda) {
    return (legenda.isfuncao === 0) ? _c('tr', {
      key: legenda.id
    }, [_c('th', [_vm._v(_vm._s(legenda.textolegenda))]), _vm._v(" "), _c('td', [_c('div', [(legenda.isoperando === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])]), _vm._v(" "), _c('td', [_c('div', [(_vm.intToBinaryString(legenda.valorlegenda)[7] === '1') ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])]), _vm._v(" "), _c('td', [_c('div', [(_vm.intToBinaryString(legenda.valorlegenda)[6] === '1') ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])]), _vm._v(" "), _c('td', [_c('div', [(_vm.intToBinaryString(legenda.valorlegenda)[5] === '1') ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])]), _vm._v(" "), _c('td', [_c('div', [(_vm.intToBinaryString(legenda.valorlegenda)[4] === '1') ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])]), _vm._v(" "), _c('td', [_c('div', [(_vm.intToBinaryString(legenda.valorlegenda)[3] === '1') ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])]), _vm._v(" "), _c('td', [_c('div', [(_vm.intToBinaryString(legenda.valorlegenda)[2] === '1') ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          _vm.selecionarStatus(legenda)
        }
      }
    }, [_vm._m(12, true)]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-sm",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#confirmacaoModal"
      },
      on: {
        "click": function($event) {
          _vm.prepararDeletarStatus(legenda)
        }
      }
    }, [_vm._m(13, true)])])])]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirAtualizarStatus),
      expression: "exibirAtualizarStatus"
    }],
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoStatus"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.textolegenda),
      expression: "statusSelecionado.textolegenda"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "textoDoStatus"
    },
    domProps: {
      "value": (_vm.statusSelecionado.textolegenda)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.statusSelecionado, "textolegenda", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoProduzindo"
    }
  }, [_vm._v("Produzindo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.isoperando),
      expression: "statusSelecionado.isoperando"
    }],
    attrs: {
      "type": "checkbox",
      "id": "textoDoStatus"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusSelecionado.isoperando) ? _vm._i(_vm.statusSelecionado.isoperando, null) > -1 : (_vm.statusSelecionado.isoperando)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.statusSelecionado.isoperando,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusSelecionado.isoperando = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusSelecionado.isoperando = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.statusSelecionado, "isoperando", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoProduzindo"
    }
  }, [_vm._v("IN1")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.in1),
      expression: "statusSelecionado.in1"
    }],
    attrs: {
      "type": "checkbox",
      "id": "textoDoStatus"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusSelecionado.in1) ? _vm._i(_vm.statusSelecionado.in1, null) > -1 : (_vm.statusSelecionado.in1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.statusSelecionado.in1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusSelecionado.in1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusSelecionado.in1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.statusSelecionado, "in1", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoProduzindo"
    }
  }, [_vm._v("IN2")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.in2),
      expression: "statusSelecionado.in2"
    }],
    attrs: {
      "type": "checkbox",
      "id": "textoDoStatus"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusSelecionado.in2) ? _vm._i(_vm.statusSelecionado.in2, null) > -1 : (_vm.statusSelecionado.in2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.statusSelecionado.in2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusSelecionado.in2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusSelecionado.in2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.statusSelecionado, "in2", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoProduzindo"
    }
  }, [_vm._v("IN3")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.in3),
      expression: "statusSelecionado.in3"
    }],
    attrs: {
      "type": "checkbox",
      "id": "textoDoStatus"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusSelecionado.in3) ? _vm._i(_vm.statusSelecionado.in3, null) > -1 : (_vm.statusSelecionado.in3)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.statusSelecionado.in3,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusSelecionado.in3 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusSelecionado.in3 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.statusSelecionado, "in3", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoProduzindo"
    }
  }, [_vm._v("IN4")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.in4),
      expression: "statusSelecionado.in4"
    }],
    attrs: {
      "type": "checkbox",
      "id": "textoDoStatus"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusSelecionado.in4) ? _vm._i(_vm.statusSelecionado.in4, null) > -1 : (_vm.statusSelecionado.in4)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.statusSelecionado.in4,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusSelecionado.in4 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusSelecionado.in4 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.statusSelecionado, "in4", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoProduzindo"
    }
  }, [_vm._v("IN5")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.in5),
      expression: "statusSelecionado.in5"
    }],
    attrs: {
      "type": "checkbox",
      "id": "textoDoStatus"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusSelecionado.in5) ? _vm._i(_vm.statusSelecionado.in5, null) > -1 : (_vm.statusSelecionado.in5)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.statusSelecionado.in5,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusSelecionado.in5 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusSelecionado.in5 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.statusSelecionado, "in5", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoProduzindo"
    }
  }, [_vm._v("IN6")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.in6),
      expression: "statusSelecionado.in6"
    }],
    attrs: {
      "type": "checkbox",
      "id": "textoDoStatus"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusSelecionado.in6) ? _vm._i(_vm.statusSelecionado.in6, null) > -1 : (_vm.statusSelecionado.in6)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.statusSelecionado.in6,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusSelecionado.in6 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusSelecionado.in6 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.statusSelecionado, "in6", $$c)
        }
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirAtualizarStatus),
      expression: "!exibirAtualizarStatus"
    }],
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.exibirListagem = true
      }
    }
  }, [_vm._v("Voltar")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirAtualizarStatus),
      expression: "!exibirAtualizarStatus"
    }],
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.novoStatus()
      }
    }
  }, [_vm._v("Novo Status")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirAtualizarStatus),
      expression: "exibirAtualizarStatus"
    }],
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.voltarAtualizarFuncao()
      }
    }
  }, [_vm._v("Voltar")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirAtualizarStatus),
      expression: "exibirAtualizarStatus"
    }],
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.atualizarStatus()
      }
    }
  }, [_vm._v("Atualizar os Dados")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Nome da Máquina")]), _vm._v(" "), _c('th', [_vm._v("Mac Address")]), _vm._v(" "), _c('th', [_vm._v("Instalada")]), _vm._v(" "), _c('th', [_vm._v("Atualizada")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Legendas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v("  Editar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Função")]), _vm._v(" "), _c('th', [_vm._v("Não Acionada")]), _vm._v(" "), _c('th', [_vm._v("F1")]), _vm._v(" "), _c('th', [_vm._v("F2")]), _vm._v(" "), _c('th', [_vm._v("F3")]), _vm._v(" "), _c('th', [_vm._v("F4")]), _vm._v(" "), _c('th', [_vm._v("F5")]), _vm._v(" "), _c('th', [_vm._v("F6")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Produzindo")]), _vm._v(" "), _c('th', [_vm._v("IN1")]), _vm._v(" "), _c('th', [_vm._v("IN2")]), _vm._v(" "), _c('th', [_vm._v("IN3")]), _vm._v(" "), _c('th', [_vm._v("IN4")]), _vm._v(" "), _c('th', [_vm._v("IN5")]), _vm._v(" "), _c('th', [_vm._v("IN6")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Editar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-red"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Apagar")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-988d6de2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Maquinas.vue
// module id = 1579
// module chunks = 1